module.exports = __webpack_public_path__ + "img/tsh-logo.ad2c716f.png";